package com.narbase.letsgo.web.views.driverGroups

import com.narbase.kunafa.core.lifecycle.Observable
import com.narbase.letsgo.web.dto.drivergroups.DriverGroupDto
import com.narbase.letsgo.web.network.basicNetworkCall
import com.narbase.letsgo.web.network.remoteProcess
import com.narbase.letsgo.web.routing.domain.admin.drivergroups.UpsertDriverGroupEndpoint
import com.narbase.letsgo.web.utils.BasicUiState

class UpsertDriverGroupViewModel {
    val upsertUiState = Observable<BasicUiState>()


    fun upsert(driverGroup: DriverGroupDto){
        basicNetworkCall(upsertUiState) {
            val dto = UpsertDriverGroupEndpoint.Request(driverGroup)
            UpsertDriverGroupEndpoint.remoteProcess(dto).data
        }

    }
}